<ion-card class="ion-margin dynamic-form-card">
  <ion-card-header *ngIf="!!title || !!subtitle" class="ion-text-center">
    <ion-card-title [attr.aria-label]="title | ariaLabel | translate:({customerName:customerName})" *ngIf="!!title">{{ title | translate: ({customerName: customerName }) }}</ion-card-title>
    <ion-card-subtitle [attr.aria-label]="subtitle | ariaLabel | translate:({customerName:customerName})" *ngIf="!!subtitle">{{ subtitle | translate: ({customerName: customerName | titlecase }) }}</ion-card-subtitle>
  </ion-card-header>
  <ion-card-content>
    <ng-content></ng-content>
  </ion-card-content>
</ion-card>
